import * as types from './ActionTypes';
import { create } from 'axios';
import { TreeConstructor } from '../utils';

const ajax = create({
  contentType: 'application/json',
  withCredentials: true
});


export const setVisibility = (data, visibility) => dispatch => {
  dispatch({
    type: types.SET_VISIBILITY,
    payload: {
      data,
      visibility
    }
  });
};

export const updateEditData = (data) => dispatch => {
  dispatch({
    type: types.UPDATE_EDIT_DATA,
    payload: data
  });
};

export const setFullTree = (data) => dispatch => {
  dispatch({
    type: types.CREATED_TREE,
    payload: data.map(tree => TreeConstructor(tree.data.registrationTree))
  });
};

export const initRecursiveTree = (relationships) => dispatch => {
  try {
    dispatch({
      type: types.SET_RECURSIVE_EDIT_DATA_STARTED
    });

    dispatch({
      type: types.SET_RECURSIVE_EDIT_DATA,
      payload: Promise.all(relationships.map( org => {
        return ajax.get(`${process.env.REACT_APP_CORE_USER_API_URL}/organizations/tree/${org.fromPartyKey || org}`);
      }))
    });
  } catch (err) {
    console.log(err);
    dispatch({
      type: types.SET_RECURSIVE_EDIT_DATA_REJECTED
    });
  }
};



// WEBPACK FOOTER //
// ./src/actions/wizard.action.js